import { render } from "./ProductoDetalle.vue?vue&type=template&id=c5be15be"
import script from "./ProductoDetalle.js?vue&type=script&lang=js&external"
export * from "./ProductoDetalle.js?vue&type=script&lang=js&external"

import "./ProductoDetalle.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__